import { DataGrid, GridColDef } from "@mui/x-data-grid"

interface Props {
    rows: readonly any[]
    columns: GridColDef<any>[]
    onRowClick?: (params: any) => void
}

const CustomTable = ({ rows, columns, onRowClick }: Props) => {


    return <DataGrid
                rows={rows}
                columns={columns}
                initialState={{
                    pagination: {
                        paginationModel: { page: 0, pageSize: 15 },
                    },
                }}
                pageSizeOptions={[10, 15, 20, 25]}
                onRowClick={onRowClick}
                sx={onRowClick ? { '& .MuiDataGrid-row': { cursor: 'pointer' } } : undefined}
            />
}

export default CustomTable